import React, { Component } from "react";
import "./index.css";
import Button from "@material-ui/core/Button";
import GroupAddIcon from "@material-ui/icons/GroupAdd";
import { connect } from "react-redux";
import instance from "../../store/actions/instance";
import { isValidPhoneNumber } from "react-phone-number-input";
import MuiPhoneNumber from "material-ui-phone-number";
import { CircularProgress } from "@material-ui/core";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const isVirginPhoneNumber = (phone) => {
  // For Virgin Mobile Kuwait. Numbers are 8 digits long and start with 41
  if (!phone) return false;
  if (
    phone.startsWith("+965") &&
    phone.split("+965")[1].startsWith("41") &&
    phone.split("+965")[1].length === 8
  )
    return true;
  return false;
};

class Invite extends Component {
  state = {
    phoneError: false,
    phoneFieldKey: Math.random() * 99999,
    countryDialCode: "",
    phone: "",

    yalaInvite: false,
    alertOpen: false,
    errorMessage: "",
  };

  handleChange = (e, eventPhone) => {
    const { settings, store } = this.props;
    if (eventPhone) {
      this.setState({ countryDialCode: eventPhone.dialCode });
    }
    if (typeof e == "string") {
      if (e.startsWith("+" + eventPhone.dialCode)) {
        this.setState({ phone: e });
      } else {
        this.setState({ phoneFieldKey: Math.random() * 999999 });
      }
      if (e.length != this.state.phone.length)
        this.setState({ phoneError: false, errorMessage: "" });
    }
  };

  isPhoneValid = () => {
    if (
      (!isValidPhoneNumber(this.state.phone) &&
        !isVirginPhoneNumber(this.state.phone)) ||
      this.state.countryDialCode == this.state.phone.substring(1)
    ) {
      return false;
    }
    return true;
  };

  getOnlyCountries = () => {
    const { settings } = this.props;

    return settings.show_all_country_codes
      ? []
      : [
          "kw",
          "sa",
          "qa",
          "om",
          "ae",
          "bh",
          "sy",
          "lb",
          "jo",
          "eg",
          "us",
          "uk",
          "cn",
        ];
  };
  t = (text) => {
    const { language } = this.props;
    if (language === "english") return text;
    const tdic = {
      "Customer is already invited": "العميل مدعو بالفعل",
      "You are not eligible to invite others": "لا يمكنك دعوة الآخرين",
      "Click here to invite": "اضغط هنا لدعوة اصدقائك",
      "Enter their phone numbers": "ادخل رقم هاتفهم",
      "Invited:": "تمت دعوة:",
      "Invite up to 3 people to order": "قم بدعوة 3 من اصدقائك للطلب!",
      "You have exceeded the limit of invited numbers": "لقد تخطيت الحد الأقصى",
    };
    return tdic[text] || text;
  };
  invite = async () => {
    const { language } = this.props;
    if (!this.state.phone || !this.isPhoneValid()) {
      this.setState({ phoneError: true });
      return;
    }
    this.setState({ inviteLoading: true, errorMessage: "" });

    try {
      const res = await instance.post("/invite_customer_to_teasers/", {
        phone: this.state.phone,
        tracking_id: this.props.order.tracking_id,
        language: language,
      });
      if (res.data.success) {
        this.setState({ alertOpen: true, phone: "" });
        this.props.updateOrder({
          ...this.props.order,
          invited_count: this.props.order.invited_count + 1,
        });
      } else if (res.data.message) {
        this.setState({ errorMessage: res.data.message, phone: "" });
      } else {
        this.setState({
          errorMessage:
            language === "arabic" ? "حدث خطأ ما" : "Something went wrong",
        });
      }
    } catch (e) {
      console.error(e);
    }
    this.setState({ inviteLoading: false });
  };

  render() {
    const { language, themeColor, history, order, store } = this.props;
    const { yalaInvite, alertOpen } = this.state;
    if (!order.customer_id) return;

    const inputLabelStyle = {
      transformOrigin: language === "english" ? "top left" : "top right",
      right: language === "arabic" ? 0 : "unset",
      left: language === "english" ? 0 : "unset",
    };
    return (
      <div
        className="border w-100 row m-0 mt-4"
        style={{ backgroundColor: "white", minHeight: 65 }}
      >
        <Snackbar
          open={alertOpen}
          autoHideDuration={3000}
          onClose={() => this.setState({ alertOpen: false })}
          classes={{ anchorOriginBottomCenter: "snackbar-bottom-70" }}
        >
          <Alert
            onClose={() => this.setState({ alertOpen: false })}
            severity="success"
          >
            {language == "english"
              ? "Invited successfully!"
              : "تمت الدعوة بنجاح!"}
          </Alert>
        </Snackbar>

        <div className="col-2" style={{ position: "relative" }}>
          <GroupAddIcon
            className="center-x-y"
            style={{ fontSize: 32, color: "#999" }}
          />
        </div>
        <div
          className={"col-10 py-3 ".concat(
            language == "english" ? "text-left" : "text-right"
          )}
        >
          <p
            style={{
              fontWeight: "bold",
              margin: 0,
              marginBottom: 2,
              marginTop: 0,
            }}
          >
            {this.t("Invite up to 3 people to order")}
          </p>
          {!!order.invited_count && (
            <p className="mb-1">
              {this.t("Invited:")} {language === "arabic" && "3/"}
              {order.invited_count}
              {language === "english" && "/3"}
            </p>
          )}
          {order.invited_count < 3 && !yalaInvite && (
            <div>
              <Button
                style={{ color: themeColor }}
                onClick={() => this.setState({ yalaInvite: true })}
              >
                <span className="bold">{this.t("Click here to invite")}</span>
              </Button>
            </div>
          )}

          {yalaInvite && order.invited_count < 3 && (
            <div className="mt-4">
              <p className="bold mb-2">{this.t("Enter their phone numbers")}</p>
              <MuiPhoneNumber
                defaultCountry={store.default_dial_code || "kw"}
                onlyCountries={this.getOnlyCountries()}
                excludeCountries={["il"]}
                countryCodeEditable={false}
                disableAreaCodes={true}
                error={this.state.phoneError}
                label={language === "english" ? "Phone *" : "رقم الهاتف *"}
                className="mb-3"
                color={"#0099cc"}
                onChange={this.handleChange}
                key={this.state.phoneFieldKey}
                value={this.state.phone}
                autoComplete="tel"
                fullWidth
                helperText={
                  this.state.phoneError
                    ? language === "english"
                      ? "Please enter a valid phone number"
                      : "الرجاء ادخال رقم هاتف صحيح"
                    : ""
                }
                FormHelperTextProps={{
                  style: {
                    textAlign: language === "arabic" && "right",
                    marginRight: language === "arabic" && 5,
                  },
                }}
                InputLabelProps={{
                  style: inputLabelStyle,
                  dir: language === "english" ? "ltr" : "rtl",
                }}
              />

              <div>
                <Button
                  variant="contained"
                  style={{
                    backgroundColor: !this.state.phone ? "#9c9c9c" : themeColor,
                    color: "white",
                    width: "100%",
                  }}
                  onClick={() => this.invite()}
                >
                  {!this.state.inviteLoading ? (
                    <span className="bold">
                      {language == "english" ? "Invite" : "ارسال الدعوة"}
                    </span>
                  ) : (
                    <span>
                      <CircularProgress
                        style={{ width: 20, height: 20, color: "white" }}
                      />
                    </span>
                  )}
                </Button>
              </div>
            </div>
          )}

          {!!this.state.errorMessage && (
            <p className="bold" style={{ color: "red", marginTop: 10 }}>
              {this.t(this.state.errorMessage)}
            </p>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    themeColor: state.store.store.settings.dark || "#0099cc",
    customTexts: state.store.store.settings.custom_texts,
    settings: state.store.store.settings,
    store: state.store.store,
  };
};

export default connect(mapStateToProps)(Invite);
